import { Routes, Route } from 'react-router';
import { Authorized, AuthProvider } from './utility/auth';
import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { VegaBox } from '@globalpayments/vega-react';

import Login from './views/login';
import Start from './views/start';
import Status from './views/status';
import UserLookup from './views/UserLookup';
import SessionInfo from './views/SessionInfo';
import ErrorPage from './views/ErrorPage';
import { Pages } from './types/pages';
import Layout from './layout';
import ConfigLookup from './views/configLookup';
import ConfigInfo from './views/configInfo';
import UserClientLookup from './views/userClientLookup';
import IFrameTesting from './views/IFrameTesting';
import Filtering from './views/filtering';
import HorizonOptOutTracker from './views/horizonOptOutTracker';
import UserManagement from './views/userManagement';

function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: true,
          },
        },
      }),
  );
  return (
    <VegaBox>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path={Pages.Login} element={<Login />}></Route>
              <Route path={Pages.Start} element={<Start />}></Route>
              <Route
                path={Pages.Home}
                element={
                  <Authorized>
                    <Status />
                  </Authorized>
                }></Route>
              <Route path={Pages.Status} element={<Status />}></Route>
              <Route
                path={Pages.UserLookup}
                element={
                  <Authorized>
                    <UserLookup />
                  </Authorized>
                }></Route>
              <Route
                path={Pages.SessionInfo}
                element={
                  <Authorized>
                    <SessionInfo />
                  </Authorized>
                }></Route>
              <Route
                path={Pages.ErrorPage}
                element={
                  <Authorized>
                    <ErrorPage />
                  </Authorized>
                }></Route>
              <Route
                path={Pages.ConfigSearch}
                element={
                  <Authorized>
                    <ConfigLookup />
                  </Authorized>
                }></Route>
              <Route
                path={Pages.ConfigInfo}
                element={
                  <Authorized>
                    <ConfigInfo />
                  </Authorized>
                }></Route>
              <Route
                path={Pages.UserClientLookup}
                element={
                  <Authorized>
                    <UserClientLookup />
                  </Authorized>
                }></Route>
              <Route
                path={Pages.Filtering}
                element={
                  <Authorized>
                    <Filtering />
                  </Authorized>
                }></Route>
              <Route
                path={Pages.HorizonOptOutTracker}
                element={
                  <Authorized>
                    <HorizonOptOutTracker />
                  </Authorized>
                }></Route>
              <Route path={Pages.IFrameTesting} element={<IFrameTesting />}></Route>
              <Route
                path={Pages.UserManagement}
                element={
                  <Authorized>
                    <UserManagement />
                  </Authorized>
                }></Route>
            </Routes>
          </Layout>
        </AuthProvider>
      </QueryClientProvider>
    </VegaBox>
  );
}

export default App;
